"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import { getProductImageList, getProductImageThumbList } from "@/lib/productImages";
import styles from "@/styles/ProductGallery.module.css";
import { useCallback, useEffect, useMemo, useState } from "react";
type ProductImageGalleryProps = {
  productId: string;
  imageAlt: string;
};
function ExpandIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 3 21 3 21 9" /><polyline points="9 21 3 21 3 15" /><line x1="21" y1="3" x2="14" y2="10" /><line x1="3" y1="21" x2="10" y2="14" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function ChevronLeftIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function ChevronRightIcon() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6" /></svg>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export function ProductImageGallery(t0) {
  const $ = _c(49);
  const {
    productId,
    imageAlt
  } = t0;
  let t1;
  if ($[0] !== productId) {
    t1 = getProductImageList(productId);
    $[0] = productId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const images = t1;
  let t2;
  if ($[2] !== productId) {
    t2 = getProductImageThumbList(productId);
    $[2] = productId;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const thumbs = t2;
  const [activeIndex, setActiveIndex] = useState(0);
  const [isLightboxOpen, setIsLightboxOpen] = useState(false);
  const hasMultiple = images.length > 1;
  const mainSrc = images[Math.min(activeIndex, images.length - 1)] ?? images[0];
  let t3;
  if ($[4] !== images.length) {
    t3 = () => {
      setActiveIndex(i => (i - 1 + images.length) % images.length);
    };
    $[4] = images.length;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const goPrev = t3;
  let t4;
  if ($[6] !== images.length) {
    t4 = () => {
      setActiveIndex(i_0 => (i_0 + 1) % images.length);
    };
    $[6] = images.length;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const goNext = t4;
  let t5;
  let t6;
  if ($[8] !== goNext || $[9] !== goPrev || $[10] !== hasMultiple || $[11] !== isLightboxOpen) {
    t5 = () => {
      const onKeyDown = e => {
        if (e.key === "Escape" && isLightboxOpen) {
          setIsLightboxOpen(false);
          return;
        }
        if (!hasMultiple) {
          return;
        }
        if (!isLightboxOpen && e.target instanceof HTMLElement) {
          const tag = e.target.tagName;
          if (tag === "INPUT" || tag === "TEXTAREA" || e.target.isContentEditable) {
            return;
          }
        }
        if (e.key === "ArrowLeft") {
          goPrev();
        } else {
          if (e.key === "ArrowRight") {
            goNext();
          }
        }
      };
      window.addEventListener("keydown", onKeyDown);
      return () => window.removeEventListener("keydown", onKeyDown);
    };
    t6 = [isLightboxOpen, hasMultiple, goPrev, goNext];
    $[8] = goNext;
    $[9] = goPrev;
    $[10] = hasMultiple;
    $[11] = isLightboxOpen;
    $[12] = t5;
    $[13] = t6;
  } else {
    t5 = $[12];
    t6 = $[13];
  }
  useEffect(t5, t6);
  let t7;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      objectFit: "contain"
    };
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== imageAlt || $[16] !== mainSrc) {
    t8 = <div className={styles.mainImage}><Image src={mainSrc} alt={imageAlt} fill={true} sizes="(max-width: 480px) 100vw, (max-width: 900px) 90vw, 480px" style={t7} unoptimized={true} priority={true} /></div>;
    $[15] = imageAlt;
    $[16] = mainSrc;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsLightboxOpen(true);
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  const t10 = `${imageAlt} – open gallery`;
  let t11;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <ExpandIcon />;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t10) {
    t12 = <button type="button" className={styles.expandBtn} onClick={t9} aria-label={t10}>{t11}</button>;
    $[20] = t10;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== goNext || $[23] !== goPrev || $[24] !== hasMultiple) {
    t13 = hasMultiple && <><button type="button" className={`${styles.navBtn} ${styles.navBtnLeft}`} onClick={goPrev} aria-label="Previous"><ChevronLeftIcon /></button><button type="button" className={`${styles.navBtn} ${styles.navBtnRight}`} onClick={goNext} aria-label="Next"><ChevronRightIcon /></button></>;
    $[22] = goNext;
    $[23] = goPrev;
    $[24] = hasMultiple;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t12 || $[27] !== t13 || $[28] !== t8) {
    t14 = <div className={styles.mainStage}>{t8}{t12}{t13}</div>;
    $[26] = t12;
    $[27] = t13;
    $[28] = t8;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] !== activeIndex || $[31] !== hasMultiple || $[32] !== imageAlt || $[33] !== images.length || $[34] !== thumbs) {
    t15 = hasMultiple && <div className={styles.thumbnails} role="tablist" aria-label={`${imageAlt} thumbnails`}>{thumbs.map((thumbSrc, i_1) => <button key={thumbSrc} type="button" role="tab" aria-selected={i_1 === activeIndex} className={`${styles.thumb} ${i_1 === activeIndex ? styles.thumbActive : ""}`} onClick={() => setActiveIndex(i_1)} aria-label={`${imageAlt} – ${i_1 + 1}/${images.length}`}><Image src={thumbSrc} alt="" fill={true} sizes="72px" style={{
          objectFit: "contain"
        }} unoptimized={true} /></button>)}</div>;
    $[30] = activeIndex;
    $[31] = hasMultiple;
    $[32] = imageAlt;
    $[33] = images.length;
    $[34] = thumbs;
    $[35] = t15;
  } else {
    t15 = $[35];
  }
  let t16;
  if ($[36] !== activeIndex || $[37] !== goNext || $[38] !== goPrev || $[39] !== hasMultiple || $[40] !== imageAlt || $[41] !== images.length || $[42] !== isLightboxOpen || $[43] !== mainSrc) {
    t16 = isLightboxOpen && <div className={styles.lightboxOverlay} role="dialog" aria-modal="true" aria-label={`${imageAlt} gallery`} onClick={e_0 => {
      if (e_0.target === e_0.currentTarget) {
        setIsLightboxOpen(false);
      }
    }}><div className={styles.lightboxContent}><button type="button" className={styles.lightboxClose} onClick={() => setIsLightboxOpen(false)} aria-label="Close">×</button>{hasMultiple && <><button type="button" className={styles.lightboxNavLeft} onClick={goPrev} aria-label="Previous"><ChevronLeftIcon /></button><button type="button" className={styles.lightboxNavRight} onClick={goNext} aria-label="Next"><ChevronRightIcon /></button></>}<div className={styles.lightboxImageWrap}><Image src={mainSrc} alt={imageAlt} fill={true} sizes="100vw" style={{
            objectFit: "contain"
          }} unoptimized={true} /></div>{hasMultiple && <div className={styles.lightboxCounter}>{activeIndex + 1} / {images.length}</div>}</div></div>;
    $[36] = activeIndex;
    $[37] = goNext;
    $[38] = goPrev;
    $[39] = hasMultiple;
    $[40] = imageAlt;
    $[41] = images.length;
    $[42] = isLightboxOpen;
    $[43] = mainSrc;
    $[44] = t16;
  } else {
    t16 = $[44];
  }
  let t17;
  if ($[45] !== t14 || $[46] !== t15 || $[47] !== t16) {
    t17 = <div className={styles.gallery}>{t14}{t15}{t16}</div>;
    $[45] = t14;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
}